import {Component, OnInit, DestroyRef, inject} from '@angular/core';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {ErrorService} from 'src/app/services/error.service';

@Component({
  selector: 'app-error-banner',
  templateUrl: './error-banner.component.html',
  styleUrls: ['./error-banner.component.scss'],
  standalone: false
})

export class ErrorBannerComponent implements OnInit {
  private _errorService: ErrorService = inject(ErrorService);
  private _destroyRef: DestroyRef = inject(DestroyRef);

  public errorMessage: string | null = null;

  public ngOnInit() {
    this._errorService.error$
      .pipe(takeUntilDestroyed(this._destroyRef))
      .subscribe(message => {
        this.errorMessage = message;
      });
  }
}
